export default __webpack_public_path__ + "static/media/international_boat_show.0ff44e12.webp";